'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrapTypeahead = require('react-bootstrap-typeahead');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ControlLabel = require('react-bootstrap/lib/ControlLabel');

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _FormGroup = require('react-bootstrap/lib/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _HelpBlock = require('react-bootstrap/lib/HelpBlock');

var _HelpBlock2 = _interopRequireDefault(_HelpBlock);

var _constants = require('../../constants');

var _containers = require('../../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DEBOUNCE_DELAY = _constants.AppConstants.DEBOUNCE_DELAY;

var Typeahead = (0, _containers.createInputContainer)(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(Typeahead, _Component);

  function Typeahead() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'value', _descriptor, _this), _initDefineProp(_this, 'onFocusValue', _descriptor2, _this), _initDefineProp(_this, 'inputValue', _descriptor3, _this), _initDefineProp(_this, 'isFocused', _descriptor4, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Typeahead, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setValueFromProps(this.props);

      if (this.props.onInputChange) {
        this.debouncedOnInputChange = (0, _debounce3.default)(this.props.onInputChange, DEBOUNCE_DELAY);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setValueFromProps(nextProps);
    }
  }, {
    key: 'setValueFromProps',
    value: function setValueFromProps(props) {
      if (typeof props.value !== 'undefined') {
        this.value = this.getCleanedValue([props.value]);
      }
    }
  }, {
    key: 'getCleanedValue',
    value: function getCleanedValue(value) {
      if (value.length > 0) {
        return value[0];
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      var _props = this.props,
          onChange = _props.onChange,
          setValue = _props.setValue,
          cleanValue = this.getCleanedValue(value),
          selectedAddNew = cleanValue && cleanValue.customOption;


      if (value.length === 1 && value[0].clear) {
        this.onFocusValue = null;
        this.refTypeahead.getInstance().clear();
        return;
      }

      // remove auto-id set by react-bootstrap-typeahead
      /* istanbul ignore next */
      if (selectedAddNew) {
        cleanValue.id = null;
      }

      this.value = cleanValue;

      // Formsy validation expects undefined but value coming back from typehead is an empty array when not selected
      setValue(cleanValue);
      onChange && onChange(cleanValue);
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      if (e.target.className.includes('bootstrap-typeahead-input-main') || e.target.className.includes('control-label')) {
        this.refTypeahead.getInstance().focus();
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      this.isFocused = true;

      if (!this.props.clearOnFocus) {
        return;
      }

      this.onFocusValue = this.value;
      this.refTypeahead.getInstance().clear();
      this.onChange([]);
      this.onInputChange('');

      // set the form input value to the previously cleared value
      this.props.setValue(this.getCleanedValue([this.value]));
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      var _props2 = this.props,
          clearOnFocus = _props2.clearOnFocus,
          optionsLabelKey = _props2.optionsLabelKey,
          setValue = _props2.setValue;


      this.isFocused = false;

      if (!clearOnFocus) {
        return;
      }

      var valueSet = this.value && (0, _get3.default)(this.value, optionsLabelKey) !== '';

      if (!valueSet && this.onFocusValue) {
        this.value = this.onFocusValue;
        this.onInputChange((0, _get3.default)(this.onFocusValue, optionsLabelKey));

        // set the form input value to the previously cleared value
        setValue(this.getCleanedValue([this.value]));
      } else {
        this.refTypeahead.getInstance()._handleActiveItemChange(this.value);
      }
    }
  }, {
    key: 'checkHasValue',
    value: function checkHasValue() {
      var optionsLabelKey = this.props.optionsLabelKey;

      var valueSet = this.value && (0, _get3.default)(this.value, optionsLabelKey) !== '';
      return valueSet || this.onFocusValue || this.inputValue;
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(value) {
      var _props3 = this.props,
          onInputChange = _props3.onInputChange,
          minLength = _props3.minLength;


      if (!value || value.length < minLength) {
        return;
      }

      this.inputValue = value;
      this.onFocusValue = value;

      onInputChange && this.debouncedOnInputChange(value);
    }
  }, {
    key: '_fuzzySearchFilterBy',
    value: function _fuzzySearchFilterBy(option, text) {
      return option;
    }
  }, {
    key: 'filterBy',
    value: function filterBy() {
      var _props4 = this.props,
          filterBy = _props4.filterBy,
          fuzzySearch = _props4.fuzzySearch,
          optionsLabelKey = _props4.optionsLabelKey;


      if (fuzzySearch) {
        return this._fuzzySearchFilterBy;
      }

      return filterBy ? filterBy : [optionsLabelKey];
    }
  }, {
    key: 'setRefTypeahead',
    value: function setRefTypeahead(comp) {
      this.refTypeahead = comp;
    }
  }, {
    key: 'renderItem',
    value: function renderItem(option, props, idx) {
      var _props5 = this.props,
          renderItem = _props5.renderItem,
          optionsLabelKey = _props5.optionsLabelKey;


      if (option && option.clear) {
        return _react2.default.createElement(
          'div',
          { className: 'dropdown-menu-item dropdown-menu-item-clear' },
          (0, _get3.default)(option, optionsLabelKey)
        );
      } else if (renderItem) {
        // defer to parent if render method was provided
        return renderItem(option, props, idx);
      }

      // render default
      return _react2.default.createElement(
        'div',
        { className: 'dropdown-menu-item' },
        (0, _get3.default)(option, optionsLabelKey)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          clearText = _props6.clearText,
          controlId = _props6.controlId,
          errorMessage = _props6.errorMessage,
          formGroupId = _props6.formGroupId,
          isDisabled = _props6.isDisabled,
          label = _props6.label,
          options = _props6.options,
          optionsLabelKey = _props6.optionsLabelKey,
          placeholder = _props6.placeholder,
          required = _props6.required,
          search = _props6.search,
          showErrorMessage = _props6.showErrorMessage,
          showRequiredMessage = _props6.showRequiredMessage,
          validationState = _props6.validationState,
          className = (0, _classnames2.default)({ disabled: isDisabled }, 'form-group-typeahead', { 'has-value': this.checkHasValue() }, { 'focused': !!this.isFocused });


      var clearOrEmpty = [];
      if (clearText) {
        clearOrEmpty = [{ clear: true }];
        clearOrEmpty[0][optionsLabelKey] = clearText;
      }

      return _react2.default.createElement(
        _FormGroup2.default,
        {
          id: formGroupId, controlId: controlId,
          className: className,
          onClick: this.onClick,
          validationState: validationState },
        label && _react2.default.createElement(
          _ControlLabel2.default,
          null,
          label,
          required && _react2.default.createElement(
            'span',
            { className: 'required' },
            '*'
          )
        ),
        _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, _extends({}, this.props, {
          disabled: isDisabled,
          filterBy: this.filterBy(),
          formNoValidation: true,
          labelKey: optionsLabelKey,
          onBlur: this.onBlur,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onInputChange: this.onInputChange,
          options: clearOrEmpty.concat(options),
          placeholder: !search && this.onFocusValue ? (0, _get3.default)(this.onFocusValue, optionsLabelKey) : placeholder,
          ref: this.setRefTypeahead,
          renderMenuItemChildren: this.renderItem,
          selected: [this.value]
        })),
        showRequiredMessage && _react2.default.createElement(
          _HelpBlock2.default,
          null,
          label || 'This field',
          ' is required.'
        ),
        showErrorMessage && _react2.default.createElement(
          _HelpBlock2.default,
          null,
          errorMessage
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Typeahead;
}(_react.Component), _class3.defaultProps = {
  allowNew: false,
  clearOnFocus: true,
  disabled: false,
  emptyLabel: 'No results found.',
  fuzzySearch: false,
  minLength: 0,
  newSelectionPrefix: '+ Add ',
  options: [],
  optionsLabelKey: 'name',
  placeholder: '',
  required: false
}, _class3.propTypes = _extends({}, _containers.inputContainerProps, {
  allowNew: _propTypes2.default.bool,
  clearOnFocus: _propTypes2.default.bool,
  clearText: _propTypes2.default.string,
  emptyLabel: _propTypes2.default.string,
  filterBy: _propTypes2.default.arrayOf(_propTypes2.default.string),
  fuzzySearch: _propTypes2.default.bool,
  icon: _propTypes2.default.string,
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  minLength: _propTypes2.default.number,
  name: _propTypes2.default.string.isRequired,
  newSelectionPrefix: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onInputChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object),
  optionsLabelKey: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  renderItem: _propTypes2.default.func,
  renderMenu: _propTypes2.default.func,
  required: _propTypes2.default.bool,
  search: _propTypes2.default.bool
}), _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'onFocusValue', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'inputValue', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'isFocused', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class) || _class) || _class;

var _default = Typeahead;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DEBOUNCE_DELAY, 'DEBOUNCE_DELAY', '/app/src/components/common-formsy/Typeahead.js');
  reactHotLoader.register(Typeahead, 'Typeahead', '/app/src/components/common-formsy/Typeahead.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-formsy/Typeahead.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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